module.exports = __webpack_public_path__ + "img/img_firstbanner_index.3c305b87.svg";